import { ChartIcon, CostModelIcon, DashboardListIcon, DashboardNewsIcon, TenderMenuIcon } from 'shared/icons/icon';

interface IProps {
	section: string;
}

const DragHandle = (props: IProps) => (
	<div className='dashboard-icon__wrapper'>
		{props.section === 'chart' && <ChartIcon className='width--32px width--32px' />}
		{props.section === 'news' && <DashboardNewsIcon />}
		{props.section === 'tender' && <TenderMenuIcon fill='white' />}
		{(props.section === 'list' || props.section === 'future-table') && <DashboardListIcon className='dashboard-icon' />}
		{props.section === 'costModel' && <CostModelIcon className='fill--white' />}
	</div>
);

export default DragHandle;
